const findProductByNumber = (number, products) => {
  return products.find(product => number == product.get('product_id'));
};

export default {
  findProductByNumber
};
